export function packageHasArenaImage(pkg) {
    return !!(pkg.venue && pkg.venue.arena && pkg.venue.arena.overview_image);
}

export function getPackageArenaImage(pkg) {
    if (!packageHasArenaImage(pkg)) {
        return null;
    }

    return pkg.venue.arena.overview_image;
}

export function isCompletePackage(
    confirmedPackage, hasFood, confirmedFood,
    optionalHotel, withoutHotel, confirmedHotel,
    hasDinner, confirmedDinner,
) {
    if (confirmedPackage) {
        if ((hasFood && confirmedFood) || !hasFood) {
            if (withoutHotel || optionalHotel || confirmedHotel) {
                if ((hasDinner && confirmedDinner) || !hasDinner) {
                    return true;
                }
            }
        }
    }

    return false;
}
